//DEPENDENCIES
import React, { useContext, useMemo } from 'react';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';
import { INTERFACE, SETTINGS } from 'pathnames.js';

// GLOBAL FUNCITONS
import { makePath } from 'functions';

// GLOBAL HELPERS
import { getListData, ListContext } from 'helpers/getListData';

// GLOBAL COMPONENTS
import Main from 'parts/main/Main';
import Table, { Filters } from 'parts/table/Table';
import Title from 'parts/title/Title';

// LOCAL VARIABLES
import { ACTIONS, COLUMNS } from 'columns';

// MAIN COMPONENT
const DealPackList = () => {
  // CONTEXT
  const { result = [] } = useContext(ListContext) || {};

  // MEMOS
  const sortedResult = useMemo(
    () =>
      result?.map(({ sale_type_category, dealer_packs }) => ({
        title: sale_type_category,
        data: dealer_packs
      })),
    [result]
  );

  // RENDER
  return (
    <Main>
      <Title title="Deal Packs" tools={<Title.AddNewUsed />} />
      <Filters>
        <Filters.Button.Active />
        <Filters.Button.NewUsed />
        <Filters.Button
          name="saleTypeCategoryId"
          options={[
            {
              label: 'Retail',
              value: '1'
            },
            {
              label: 'Wholesale',
              value: '2'
            }
          ]}
        />
        <Filters.Search name="packTitle" placeholder="Search by title" />
        <Filters.Reset />
      </Filters>
      <Table.Sorted sortedResult={sortedResult} mobilePreviewKeys={['pack_title', 'is_active']} />
    </Main>
  );
};

// EXPORT
export default getListData(DealPackList, {
  key: 'inventoryPacks',
  path: makePath(INTERFACE.settings, SETTINGS.inventoryPacks),
  fetchArgs: {
    endpoint: ENDPOINTS.admin.dealPacks.list
  },
  defaults: {
    startRow: null
  },
  columns: [
    {
      key: 'pack_title',
      label: 'Title'
    },
    {
      key: 'pack_amount',
      label: 'Amount',
      width: 85,
      component: Table.Dollars
    },
    {
      ...COLUMNS.newUsed
    },
    {
      ...COLUMNS.active,
      tooltip: 'Only active deal packs will be available while adding a sale.'
    },
    COLUMNS.updatedOn,
    COLUMNS.updatedBy
  ],
  actions: [ACTIONS.edit('dealer_pack_id')]
});
